import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export const useSliderItemSortable = ({ id }: { id: string }) => {
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging && {
      opacity: 0.8,
      cursor: 'grabbing',
      zIndex: 100,
    }),
  };

  return { setNodeRef, attributes, listeners, style, isDragging };
};
